import { render, staticRenderFns } from "./occupationAdd.vue?vue&type=template&id=1ec00b92&scoped=true&"
import script from "./occupationAdd.vue?vue&type=script&lang=ts&"
export * from "./occupationAdd.vue?vue&type=script&lang=ts&"
import style0 from "./occupationAdd.vue?vue&type=style&index=0&id=1ec00b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec00b92",
  null
  
)

export default component.exports